export const TYPE_IMAGE = {
  regex: new RegExp('image/(jpg|jpeg|png)$'),
  formats: '.jpg, .jpeg, .png',
  error: 'imageFormatError',
};
